import {
    Col,
    Row,
} from 'reactstrap';

import ChipIcon from '../ChipIcon';

const CarbonEmissions = ({
    t,
    emissions,
}) => (
    <>
        <p className="overview-esg-rating__eyebrow mb-2">
            {t('Carbon Emissions')}
        </p>
        <Row className="g-2 mb-3">
            {(emissions || []).map((item) => (
                <Col xs="12" md="4" key={item.key}>
                    <div className="overview-esg-rating__metric-card">
                        <div className="d-flex justify-content-between align-items-center">
                            <span className="overview-esg-rating__metric-label">
                                {item.label}
                            </span>
                            <ChipIcon />
                        </div>
                        <span className="overview-esg-rating__metric-value">
                            {item.value}
                        </span>
                        <span className="overview-esg-rating__metric-unit">
                            {item.unit}
                        </span>
                        <span className="overview-esg-rating__hint">
                            {t(item.hint)}
                        </span>
                    </div>
                </Col>
            ))}
        </Row>
    </>
);

export default CarbonEmissions;
